/**
 * Shared sorting utilities for issues
 */

import type { IssueSeverity } from '../domain'

export const SEVERITY_ORDER: Record<IssueSeverity, number> = {
  critical: 0,
  high: 1,
  medium: 2,
  low: 3,
}

export function compareSeverity(a: IssueSeverity, b: IssueSeverity): number {
  return SEVERITY_ORDER[a] - SEVERITY_ORDER[b]
}

export function compareDates(a: string, b: string): number {
  return new Date(a).getTime() - new Date(b).getTime()
}
